/* import __COLOCATED_TEMPLATE__ from './header-new-workflows-dropdiwn-items.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();